// extracted by mini-css-extract-plugin
export default {"root":"_3mepH","stat":"_1MBwR","label":"_1L5L9"};